import { Component, Input, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { LaunchDarklyService } from "../../launchDarkly/launchDarkly.service";

@Component({
  selector: "panel-header",
  templateUrl: "./panel-header.component.html",
  styleUrls: ["./panel-header.component.scss"],
})
export class PanelHeaderComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  tier: string;

  src: string;

  // Feature flagging new product logos
  flagSubscription: Subscription;
  showNewLogos: boolean = false;

  constructor(public launchDarklyService: LaunchDarklyService) {
    this.initFlags(launchDarklyService);
    this.flagSubscription = launchDarklyService.flagChange.subscribe(() =>
      this.initFlags(launchDarklyService)
    );
  }

  initFlags(launchDarklyService: LaunchDarklyService) {
    this.showNewLogos = launchDarklyService.getFlag(
      "mosaic-ui-new-product-logos"
    );
  }

  ngOnInit(): void {
    if (this.tier === "starter" && this.showNewLogos) {
      switch (this.title.toLowerCase()) {
        case "reading":
          this.src = "../../assets/images/star_reading.svg";
          break;
        case "myon":
          this.src = "../../assets/images/myon.svg";
          break;
        case "star spanish":
          this.src = "../../assets/images/star_spanish.svg";
          break;
        case "math":
          this.src = "../../assets/images/star_math.svg";
          break;
        case "early literacy":
          this.src = "../../assets/images/star_early_literacy.svg";
          break;
        case "freckle":
          this.src = "../../assets/images/freckle.svg";
          break;
        case "lalilo":
          this.src = "../../assets/images/lalilo.svg";
          break;
        case "accelerated reader":
          this.src = "../../assets/images/accelerated_reader.svg";
          break;
        case "starcbm":
        case "star cbm":
          this.src = "../../assets/images/star_cbm.svg";
          break;
      }
    } else if (this.tier === "starter") {
      switch (this.title.toLowerCase()) {
        case "reading":
          this.src = "../../assets/images/star-reading.png";
          break;
        case "myon":
          this.src = "../../assets/images/myON.png";
          break;
        case "math":
          this.src = "../../assets/images/star-math.png";
          break;
        case "early literacy":
          this.src = "../../assets/images/star-early-literacy.png";
          break;
        case "freckle":
          this.src = "../../assets/images/freckle.png";
          break;
        case "lalilo":
          this.src = "../../assets/images/lalilo.png";
          break;
        case "accelerated reader":
          this.src = "../../assets/images/accelerated-reader.png";
          break;
        case "starcbm":
        case "star cbm":
          this.src = "../../assets/images/starCBM.png";
          break;
      }
    }
  }
}
